<template>
	<div class="view-student-fee-structure">
		<Modal
			:show="showFeeStructure"
			content_class="col-12 col-lg-10 col-xl-9 confirm-modal"
		>
			<template slot="content" v-if="selected_fee_structure">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								Fee Structure: {{ selected_fee_structure.ref }}
							</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showFeeStructure', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="no-padding">
						<div class="row">
							<div class="col-12 col-xl-11">
								<div class="card fee-card">
									<div class="clearfix">
										<div
											class="f-r status tx-green"
											:class="{
												'tx-yellow':
													selected_fee_structure.status !==
													'initiated',
											}"
										>
											{{ selected_fee_structure.status }}
										</div>
									</div>

									<div class="ref">
										{{ selected_fee_structure.ref }}
									</div>
									<div class="class">
										FEE STRUCTURE FOR
										{{ selected_fee_structure.class }}
									</div>
									<div class="time">
										Processing Period:
										<span class="date"
											>{{
												moment(
													selected_fee_structure.applicable_period_from,
												).format('Do MMM YYYY')
											}}
											-
											{{
												moment(
													selected_fee_structure.applicable_period_to,
												).format('Do MMM YYYY')
											}}</span
										>
									</div>
									<div class="total">
										{{ selected_fee_structure.currency }}
										{{
											utils.numberWithCommas2(
												selected_fee_structure.total,
											)
										}}
									</div>

									<div
										class="term"
										v-for="(
											term, k
										) in selected_fee_structure.terms"
										:key="k"
									>
										<div class="name">
											{{ term.name }} ({{
												moment(term.from).format(
													'Do MMM YYYY',
												)
											}}
											-
											{{
												moment(term.to).format(
													'Do MMM YYYY',
												)
											}})
										</div>
										<div class="small-title">MANDATORY</div>

										<div
											class="price-item"
											v-for="(item, j) in term.mandatory"
											:key="j"
										>
											<div class="row">
												<div class="col-8 item-title">
													{{ item.name }}
												</div>
												<div class="col-4 amount">
													{{
														utils.numberWithCommas2(
															item.cost,
														)
													}}
												</div>
											</div>
										</div>

										<div class="small-title">OPTIONAL</div>
										<div
											class="price-item"
											v-for="(item, l) in term.optional"
											:key="l"
										>
											<div class="row">
												<div class="col-8 item-title">
													{{ item.name }}
												</div>
												<div class="col-4 amount">
													{{
														utils.numberWithCommas2(
															item.cost,
														)
													}}
												</div>
											</div>
										</div>

										<div class="total-box">
											<div class="row">
												<div class="col-8 item-title">
													Total
												</div>
												<div class="col-4 amount">
													{{ calculateTotal(term) }}
												</div>
											</div>
										</div>
									</div>

									<div class="sum-total clearfis">
										<div class="total f-r">
											{{
												selected_fee_structure.currency
											}}
											{{
												utils.numberWithCommas2(
													selected_fee_structure.total,
												)
											}}
										</div>
									</div>

									<div class="btn-box">
										<button
											class="f-r btn btn-green btn-long"
											v-if="
												selected_fee_structure.status ===
												'initiated'
											"
											@click="
												processFeeStructure(
													selected_fee_structure,
												)
											"
										>
											Process
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	components: {
		Modal: () => import('../templates/others/modal'),
	},
	computed: {
		...mapGetters([
			'loading',
			'selected_fee_structure',
			'showFeeStructure',
		]),
	},
	data() {
		return {
			utils,
			moment,
		};
	},
	methods: {
		...mapActions(['processFeeStructure']),
		calculateTotal(term) {
			let total = 0;
			for (let i = 0; i < term.mandatory.length; i++) {
				if (term.mandatory[i].cost) {
					total += term.mandatory[i].cost;
				}
			}

			for (let i = 0; i < term.optional.length; i++) {
				if (term.optional[i].cost) {
					total += term.optional[i].cost;
				}
			}

			return `KES ${utils.numberWithCommas(total)}`;
		},
	},
	mounted() {},
};
</script>

<style lang="less">
.view-student-fee-structure {
	.total.final {
		color: var(--ne-green) !important;

		&.tx-yellow {
			color: var(--ne-yellow) !important;
		}
	}
}
</style>
